<template>
  <GeoIPOverlay :config="config" />
</template>

<script>
import GeoIPOverlay from "../../components/GeoIPOverlay/GeoIPOverlay.vue";

export default {
  name: "app",
  components: {
    GeoIPOverlay
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
